<header class="bg-primary p-3">

  <div class="container">

    <nav class="navbar main-nav">

      <a class="navbar-brand d-flex align-items-center" [routerLink]="[ data.URL_HOME ] | localize">
        <img class="logo" src="./assets/imagens/logo_branca.png">
      </a>

      <ul class="float-right">
        <li class="drop-down">
          <a><i class="flag-icon {{ idiomaSelecionado.FLAG }}"></i><span
              class="d-none">{{ idiomaSelecionado.TITULO }}</span><i class="fas fa-angle-down ml-2"></i></a>
          <ul>
            <li *ngFor="let idioma of idiomas">
              <a *ngIf="idiomaSelecionado.CODIGO != idioma.CODIGO" (click)="alterarIdioma(idioma.CODIGO)"><i
                  class="flag-icon {{ idioma.FLAG }} mr-2"></i>{{ idioma.TITULO }}</a>
            </li>
          </ul>
        </li>
      </ul>

    </nav>

  </div>

</header>

<main>

  <div class="container">
    
    <div class="row mt-5 text-justify">
      <div class="col-md-12">
        <h2 class="text-center">{{ data.TITULO }}</h2>
        <p *ngFor="let cabecalho of data.CABECALHO">{{ cabecalho.TEXTO }}</p>
      </div>
    </div>
    
    <div class="row d-flex justify-content-center">
      <div class="col-md-12">
        <h3 class="text-primary">{{ data.SUBTITULO }}</h3>
        <hr>
      </div>
    </div>
    
    <form [formGroup]="formGroup" (ngSubmit)="onSubmit()">
    
      <div class="row">
    
        <div class="col-lg-6">
          <div class="control-group">
            <div class="form-group mb-0 pb-2">
              <label class="control-label">{{ data.NOME }} <span class="text-danger">*</span></label>
              <input class="form-control form-control-sm" formControlName="formNome" type="text">
    
              <!-- Mensagens de erro -->
              <div *ngFor="let validator of data.VALIDATOR.NOME">
                <span class="text-danger"
                  *ngIf="formGroup.get('formNome').hasError(validator.TYPE) && (formGroup.get('formNome').dirty || formGroup.get('formNome').touched) ">{{
                  validator.MENSAGEM }}</span>
              </div>
              <!-- Mensagens de erro -->
    
            </div>
          </div>
        </div>
    
        <div class="col-lg-6">
          <div class="control-group">
            <div class="form-group mb-0 pb-2">
              <label class="control-label">{{ data.EMAIL }} <span class="text-danger">*</span> </label>
              <input class="form-control form-control-sm" formControlName="formEmail" type="text">
    
              <!-- Mensagens de erro -->
              <div *ngFor="let validator of data.VALIDATOR.EMAIL">
                <span class="text-danger"
                  *ngIf="formGroup.get('formEmail').hasError(validator.TYPE) && (formGroup.get('formEmail').dirty || formGroup.get('formEmail').touched) ">{{
                  validator.MENSAGEM }}</span>
              </div>
              <!-- Mensagens de erro -->
    
            </div>
          </div>
        </div>
    
      </div>
    
      <div class="row mt-2 mb-5">
        <div class="col-md-12">
          <div class="control-group">
            <div class="form-group mb-0">
              <button class="btn btn-primary" [disabled]="!formGroup.valid">{{ data.BOTAO_CONFIRMAR }}</button>
            </div>
          </div>
        </div>
      </div>
    
    </form>

  </div>

</main>